import QRGateway from './QRGateway';
export { PollingEvents, PollingState } from './Interface';

export { QRGateway };
